/* eslint-disable @next/next/no-img-element */
import React from 'react';

import cx from 'classnames';

import { useServiceSelection } from 'hooks/page/services/useServiceSelection';
import { TServiceProps } from 'hooks/page/services/useServicesPage';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';

import { Button } from '../Button/Button';

import s from './PlayfulService.module.css';

export const PlayfulServiceHome = ({
  service,
  listView = false,
  disabled = true,
  onClick,
}: TServiceProps) => {
  const {
    bnplUnitPrice,
    durationText,
    displayedPrice,
    depositText,
    optionText,
    bnplCapabilities,
  } = useServiceSelection({
    service,
    disabled,
    onClick,
  });

  let popovertarget;
  let popovertargetaction;
  const hasOptions = Boolean(service.options?.length);

  if (hasOptions) {
    popovertarget = 'service-option-modal';
    popovertargetaction = 'show';
  }

  const { name, description, image } = service;

  return (
    <article
      className={cx(s.root, {
        [s.listItem]: listView,
      })}
    >
      <div className={s.imageWrapper}>
        <img className={s.image} src={image} alt={name} loading="lazy" />
      </div>

      <div className={s.content}>
        <div className={s.description}>
          <h3 className={s.title}>{name}</h3>
          {description && <p className={s.summary}>{description}</p>}
          {depositText && <p className={s.deposit}>{depositText}</p>}
          {optionText && (
            <div data-testid="option" className={s.serviceOption}>
              {optionText}
            </div>
          )}

          <ul className={s.options}>
            <li className={s.option}>
              <b>Price:</b> {displayedPrice}
            </li>
            <li className={s.option}>
              <b>Duration:</b> {durationText}
            </li>
          </ul>

          {bnplUnitPrice ? (
            <div className={s.bnplEligible}>
              <BuyNowPayLaterPromo
                unitAmount={bnplUnitPrice}
                paymentMethodTypes={bnplCapabilities}
              />
            </div>
          ) : null}
        </div>

        <Button
          className={s.button}
          onClick={() => onClick(service.guid)}
          popovertarget={popovertarget}
          popovertargetaction={popovertargetaction}
        >
          Book
        </Button>
      </div>
    </article>
  );
};
